module.exports = __webpack_public_path__ + "static/media/squareHooks@3x.9d7e1c4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/squareHooks@3x.png
// module id = 390
// module chunks = 0 1